import { createFileRoute, redirect } from '@tanstack/react-router'
import { createClient } from '../util/supabase/component'

export const Route = createFileRoute('/private')({
  beforeLoad: async ({ location }) => {
    const supabase = createClient()
    const {
      data: { session },
    } = await supabase.auth.getSession()
    console.log({ session })
    if (!session) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw redirect({
        to: '/auth/login',
        search: {
          // Use the current location to power a redirect after login
          // (Do not use `router.state.resolvedLocation` as it can
          // potentially lag behind the actual current location)
          redirect: location.href,
        },
      })
    }
  },
})
